<template>
  <el-select v-model="inputValue" placeholder="">
    <el-option
      v-for="item in BooleanOptions"
      :key="item.value"
      :value="item.value"
      :label="item.label"
    />
  </el-select>
</template>

<script>
export default {
  name: 'RestFormSelectBoolean',

  props: {
    value: {
      required: false
    }
  },

  data() {
    return {
      BooleanOptions: [
        {
          value: 0,
          label: this.$t('Rest_Form_No')
        },
        {
          value: 1,
          label: this.$t('Rest_Form_Yes')
        }
      ]
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestFormSelectBoolean.vue